<template>
    <material-card color="warning" :title="$t('Pages.ScheduledOvertimes.select_users')">
        <v-layout wrap align-start justify-start>
            <v-flex lg3>
                <v-text-field v-debounce:300ms="refresh" slot="actions-prepend"
                              v-model="search.q"
                              append-icon="search"
                              :label="$t('Core.Fields.search')"
                              single-line
                              hide-details
                              color="purple"
                ></v-text-field>
            </v-flex>
            <v-flex lg8 offset-lg1>
                <v-autocomplete
                        :items="sectors"
                        v-model="search.sector"
                        :error-messages="errors.first('sector')"
                        :label="$t('Pages.Sectors.title_singular')"
                        name="sector"
                        color="indigo"
                        clearable
                        multiple
                        autocomplete
                        item-text="name"
                        item-value="id"
                ></v-autocomplete>
            </v-flex>
        </v-layout>
        <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :rows-per-page-items="perPageItems"
                select-all
                :total-items="total"
                item-key="id"
        >
            <template slot="headers" slot-scope="{headers}">
                <tr>
                    <th>
                        <v-checkbox
                                v-model="all"
                                :indeterminate="indeterminate"
                                primary
                                hide-details
                                @click.stop="toggleAll"
                        ></v-checkbox>
                    </th>
                    <th
                            v-for="header in headers"
                            :key="header.text"
                            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.align ? 'text-xs-' + header.align : 'text-xs-left']"
                            @click="changeSort(header.value, header.sortable)"
                    >
                        <span class="subheading font-weight-light text-primary" v-text="header.text"/>
                        <v-icon small v-if="header.sortable">arrow_upward</v-icon>
                    </th>
                </tr>
            </template>
            <template slot="items" slot-scope="{item}">
                <tr>
                    <td>
                        <v-checkbox
                                v-model="item.selected"
                                primary
                                hide-details
                                @click.stop="toggleSingle(item)"
                        ></v-checkbox>
                    </td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.profile.name }}</td>
                    <td>{{ item.sectors && item.sectors.length > [0] ? item.sectors[0].name : $t('Common.not_assigned')}}</td>
                </tr>
            </template>
        </v-data-table>
    </material-card>
</template>

<script>
    import i18n from '@/i18n'
    import _ from 'lodash'
    export default {
        name: "check-users-table",
        components: {},
        props: {
            items: {
                type: Array,
                required: true
            },
            selected: {
                type: Array,
                required: true,
                default: []
            },
            total: {
                type: Number,
                default: 0,
            },
            loading: {
                type: Boolean,
                required: true
            },
            hideActions: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            headers: [
                {
                    sortable: true,
                    text: '#',
                    value: 'id'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.Users.model.name'),
                    value: 'profile.name'
                },
                {
                    sortable: false,
                    text: i18n.t('Pages.Sectors.title_singular'),
                    value: 'sector.name'
                }
            ],
            all: false,
            //selected: [],
            pagination: {},
            perPageItems: [10, 15, 25, 50, 100],
            sectors: [],
            workplaces: [],
            search: {sector: null, workplace: null},
        }),
        computed:{
            indeterminate() {
                return !this.all && this.selected && this.items && (_.intersectionBy(this.selected, this.items, 'id').length > 0);
            }
        },
        created(){
            this.getSectors();
            //this.getWorkplaces();
        },
        methods: {
            refresh(){
                let data = {
                    q: this.search.q,
                    sector: this.search.sector,
                    workplace: this.search.workplace,
                    page: this.pagination.page,
                    pagination: this.pagination.rowsPerPage,
                    orderBy: this.pagination.sortBy ? (this.pagination.sortBy + "," + (this.pagination.descending ? 'desc' : 'asc')) : null
                };

                this.$emit('refresh', data);
            },
            toggleAll () {
                let result = this.selected;
                if(this.items && this.items.length) {
                  if(this.all) {
                    result = _.differenceBy(result, this.items, 'id');
                  }
                  else{
                    result = _.unionBy(result, this.items, 'id');
                  }
                }
                this.select(result);
                this.all != this.all;
            },
            toggleSingle(item){
                if(item.selected) {
                    _.remove(this.selected, {
                        id: item.id
                    });
                }
                else{
                    this.selected.push(item);
                }

                this.select(this.selected);
            },
            changeSort (column, sortable) {
                if(!sortable)return;

                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending;
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false;
                }

                this.refresh();
            },
            getSectors(){
                this.repositories.sector.all().then((response) => {
                    this.sectors = response.data.data;
                });
            },
            getWorkplaces(){
                this.repositories.workplace.all().then((response) => {
                    this.workplaces = response.data.data;
                });
            },
            select(selected){
                this.$emit('select', selected);
            },
            checkAll(){
                let result = true;
                for(var i = 0; i < this.items.length; i++){
                    let item = this.items[i];
                    result = result && _.find(this.selected, function(obj) {
                        return obj.id === item.id;
                    })
                }
                this.all = result;
            }
        },
        watch: {
            'search.sector': function(){
                this.refresh();
            },
            'search.workplace': function(){
                this.refresh();
            },
            pagination(val){
                this.refresh();
            },
            items(val){
                this.checkAll();
            }
        }
    }
</script>

<style scoped>

</style>
